// extracted by mini-css-extract-plugin
export default {"how_we_work_with":"WhoWeWorkWith_how_we_work_with__Uoakf","partner_card":"WhoWeWorkWith_partner_card__Exems"};